import { render } from "./insureTr.vue?vue&type=template&id=584f7760&scoped=true"
import script from "./insureTr.vue?vue&type=script&lang=js"
export * from "./insureTr.vue?vue&type=script&lang=js"

import "./insureTr.vue?vue&type=style&index=0&id=584f7760&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584f7760"]])

export default __exports__